import SimpleFillSymbol from '@arcgis/core/symbols/SimpleFillSymbol';
import SimpleLineSymbol from '@arcgis/core/symbols/SimpleLineSymbol';
import { getColorValue } from '.';

export const createPolygonSymbol = (
  boundaryColor = '',
  polygonColor = '',
): SimpleFillSymbol => {
  const boundaryRGB = getColorValue(boundaryColor);
  const polygonRGB = getColorValue(polygonColor);

  return new SimpleFillSymbol({
    color: [...polygonRGB, 0.2],
    outline: new SimpleLineSymbol({
      color: boundaryRGB,
      width: 2,
    }),
  });
};
